module.exports = __webpack_public_path__ + "img/_empty_states_customer_notes.b77deadd.svg";